import { render, staticRenderFns } from "./FormContact.vue?vue&type=template&id=94aff312&"
import script from "./FormContact.vue?vue&type=script&lang=ts&"
export * from "./FormContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94aff312')) {
      api.createRecord('94aff312', component.options)
    } else {
      api.reload('94aff312', component.options)
    }
    module.hot.accept("./FormContact.vue?vue&type=template&id=94aff312&", function () {
      api.rerender('94aff312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContactData/FormContact.vue"
export default component.exports